module.exports = __webpack_public_path__ + "static/Symphonia1-3558e64563acd9d5c2f8e63442ea5698.png";